<template>
    <b-modal class="modal-cover"
             v-model="visible"
             @show="$emit('show')"
             @hide="$emit('hide')"
             :scrollable="!disableScrollable"
             :centered="centered"
             :size="large ? 'lg' : 'md'"
             :hide-header="hideHeader || clean"
             :hide-footer="hideFooter || clean"
             header-bg-variant="white"
             :no-close-on-backdrop="noCloseOnBackdrop"
             :dialog-class="dialogClass"
             :content-class="contentClass"
             :body-class="maxHeight?'h-100':''">
        <template #modal-header>
            <div class="d-flex flex-row w-100">
                <h5 class="header-title">
                    {{ header }}
                </h5>
                <b-spinner small v-show="showLoading" class="mt-auto mb-auto"></b-spinner>
                <slot name="header"></slot>
            </div>
        </template>
        <slot>
        </slot>
        <template #modal-footer>
            <div class="d-flex flex-row">
                <slot name="footer"></slot>
                <b-button class="ml-2" @click="cancel()">Cancel</b-button>
                <mini-button v-if="!noOkButton" class="ml-2" variant="primary"
                             name="modal-ok" :loading="okLoading"
                             @btnClick="ok()">
                    {{ okLabel }}
                </mini-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "ReBModal",
    components: {MiniButton},
    props: {
        header: {
            type: String,
            default: '提醒'
        },
        loading: {
            type: Boolean,
            default: false
        },
        okLoading: {
            type: Boolean,
            default: false
        },
        centered: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        superLarge: {
            type: Boolean,
            default: false
        },
        fitContent: {
            type: Boolean,
            default: false
        },
        maxHeight: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Boolean,
            default: false
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        clean: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        enablePopover: {
            type: Boolean,
            default: false
        },
        disableScrollable: {
            type: Boolean,
            default: false
        },
        noAutoHide: {
            type: Boolean,
            default: false
        },
        noOkButton: {
            type: Boolean,
            default: false
        },
        okLabel: {
            type: String,
            default: 'OK'
        },
        noMaxWidth: Boolean,
    },
    data() {
        return {
            visible: false,
            showLoading: this.loading,
            tempObject: null
        }
    },
    computed: {
        dialogClass() {
            let tempList = [];
            if (this.fitContent) {
                tempList.push('large-dialog fit-content');
            } else if (this.superLarge) {
                tempList.push('large-dialog');
            }
            if (this.maxHeight) {
                tempList.push('content-height-max-available');
            }
            if (this.maxWidth) {
                tempList.push('w-85 large-dialog');
            }
            if (this.noMaxWidth) {
                tempList.push('no-max-width')
            }
            return tempList.join(' ');
        },
        contentClass() {
            let tempList = [];
            tempList.push(`content-cover${this.clean ? '-clean' : ''}`);
            if (this.enablePopover) {
                tempList.push('cover-fit-pop');
            }
            if (this.maxHeight) {
                tempList.push('h-100');
            }
            return tempList.join(' ');
        },
    },
    watch: {
        loading() {
            this.showLoading = this.loading;
        }
    },
    methods: {
        showModal(object) {
            this.visible = true;
            if (object !== undefined) {
                this.tempObject = object;
                this.$emit("dataSet", object);
            }
        },
        changeLoading(val) {
            this.showLoading = val;
        },
        getTempObject() {
            return this.tempObject;
        },
        hide() {
            this.visible = false;
        },
        //----
        ok() {
            this.$emit('ok');
            if (!this.noAutoHide) {
                this.hide();
            }
        },
        cancel() {
            this.$emit('cancel');
            this.hide();
        },
    }
}
</script>

<style scoped>
.header-title {
    margin: 0.75rem auto 0.75rem 1rem;
    color: black;
}
</style>

<style>
.content-cover {
    resize: vertical;
}

.content-cover-clean {
    background-color: rgba(0, 0, 0, 0) !important;
    border: none !important;
    overflow: unset !important;
}

.content-cover-clean .modal-body {
    padding: 0 !important;
}

.large-dialog {
    max-width: 85% !important;
}

.fit-content {
    width: max-content !important;
    margin: auto !important;
}

.cover-fit-pop {
    overflow: unset !important;
}

.content-height-max-available {
    height: calc(100% - 3.5rem) !important;
}

.no-max-width {
    max-width: 100% !important;
}
</style>
